"use client"

import { DropStatus } from "@anaconda/core/drop/types"

interface Props {
  status: DropStatus
  className?: string
  children: React.ReactNode
}

const statusStyles: Record<DropStatus, string> = {
  [DropStatus.Upcoming]: "text-foreground/60",
  [DropStatus.Minting]: "text-brand",
  [DropStatus.Ended]: "text-foreground/60",
}

export function DropStatusBadge({ status, className, children }: Props) {
  return (
    <div
      className={`flex items-center gap-2 ${statusStyles[status]} ${className}`}
    >
      <svg
        width="6"
        height="6"
        viewBox="0 0 6 6"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <title>Drop status</title>
        <circle cx="3" cy="3" r="3" fill="currentColor" />
      </svg>

      {children}
    </div>
  )
}
